import moment from 'moment'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {KTSVG} from '../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {
  DeleteData,
  GetAllData,
  getBusinessName,
  setDefaultBusinessName,
} from './BusinessNameSlice/BusinessSlice'
import CreateBusinessNamePopup from './Modal/CreateBusinessNamePopup'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import InsertNewData from '../../../../Components/InsertNewData'
import {getAllUserDetails, getIsDefaultRegion} from '../Overview/OverviewSlice/UserDetailsSlice'
import {BusinessNumber} from '../../../../../services/cellcast.type'
import clsx from 'clsx'

type Props = {
  showModalNewBusiness: boolean;
  setShowModalNewBusiness: (visible: boolean) => void;
  onClickLearnMore: () => void;
}
const BusinessNameList: React.FC<Props> = ({
  showModalNewBusiness,
  setShowModalNewBusiness,
  onClickLearnMore,
  }) => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const bussinessName: any = useSelector(getBusinessName)
  const userData: any = useSelector(getAllUserDetails)

  const BusinessName = useMemo(
    () => <CreateBusinessNamePopup show={showModalNewBusiness} handleClose={() => setShowModalNewBusiness(false)} />,
    [showModalNewBusiness]
  )

  useEffect(() => {
    dispatch(GetAllData())
  }, [])
  useEffect(() => {
    if (confirm == true) {
      dispatch(DeleteData(deleteIds))

      setConfirm(false)
    }
  }, [confirm])

  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds(id)
  }

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete business name?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const isShareNumber = useCallback(
    (senderData: BusinessNumber) => {
      if (senderData && senderData.allocatedUsers && Array.isArray(senderData.allocatedUsers)) {
        const userID = userData._id

        if (userID && senderData.allocatedUsers.includes(userID)) {
          return true
        }
      }
      return false
    },
    [userData]
  )

  const bgColor: any = {
    REQUESTED: 'warning',
    ACTIVE: 'success',
    DENIED: 'danger',
  }
  return (
    <>
      {BusinessName}
      {confirmation}
      <div className={`card`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <div>
              <span className='card-label fw-bolder fs-3 mb-1 small-title'>
                Custom Business Name (Alpha ID)
              </span>
              <i
                onClick={() => onClickLearnMore()}
                className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
              />
            </div>
          </h3>
          {AuthenticateUser('create-new-business-name') && (
            <div
              className='card-toolbar'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title='Create new business name'
            >
              <span
                data-testid='btnAddBusinessName'
                className='btn btn-sm  btn-primary'
                onClick={() => setShowModalNewBusiness(true)}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-6' />
                New business name
              </span>
            </div>
          )}
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        {bussinessName?.length > 0 ? (
          <div className='card-body py-3'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bolder text-muted'>
                    <th className='min-w-150px'>Business Name</th>
                    <th>REQUESTED</th>
                    <th>APPROVED</th>
                    <th>STATUS</th>

                    <th className='min-w-100px text-center'>Actions</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {bussinessName?.map((val: any, i: number) => (
                    <tr key={i}>
                      <td>{val?.businessname}</td>
                      <td>{moment(val?.requestedAt).fromNow()}</td>
                      <td>{val?.status === 'ACTIVE' ? moment(val?.approvedAt).fromNow() : '-'}</td>
                      <td>
                        <span
                          className={`badge badge-light-${bgColor?.[val?.status]}`}
                          style={{textTransform: 'capitalize'}}
                        >
                          {val?.status}{' '}
                        </span>{' '}
                      </td>

                      <td>
                        {!isShareNumber(val) ? (
                          <>
                            <div className={clsx('d-flex justify-content-center flex-shrink-0')}>
                              {AuthenticateUser('create-new-business-name') &&
                                val?.status == 'ACTIVE' && (
                                  <>
                                    {' '}
                                    {val?.isDefault == false ? (
                                      <button
                                        onClick={() =>
                                          dispatch(
                                            setDefaultBusinessName({
                                              businessNameId: val?._id,
                                              isDefault: true,
                                            })
                                          )
                                        }
                                        className={clsx(
                                          'btn btn-sm btn-light-primary border-light-primary border-dashed me-5',
                                          {'d-none': !isDefaultRegion}
                                        )}
                                      >
                                        Set Default
                                      </button>
                                    ) : (
                                      <button
                                        className={clsx(
                                          'btn btn-sm btn-light-primary border-light-primary border-dashed me-5',
                                          {'d-none': !isDefaultRegion}
                                        )}
                                        onClick={() =>
                                          dispatch(
                                            setDefaultBusinessName({
                                              businessNameId: val?._id,
                                              isDefault: false,
                                            })
                                          )
                                        }
                                      >
                                        {' '}
                                        Default
                                      </button>
                                    )}
                                  </>
                                )}

                              {AuthenticateUser('create-new-business-name') && (
                                <span
                                  onClick={() => handleDelete(val?._id)}
                                  className='btn btn-icon btn-light-primary border-light-primary btn-sm delete_action'
                                >
                                  <KTSVG
                                    path='/media/icons/duotune/general/gen027.svg'
                                    className='svg-icon-3'
                                  />
                                </span>
                              )}
                            </div>
                          </>
                        ) : (
                          <div className='d-flex justify-content-center flex-shrink-0'>--</div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
        ) : (
          <InsertNewData
            message={{
              title: 'No Business Name setup (yet!)',
              subtitle: `It looks like you haven't applied for a Business Name, get started to build more trust with your customers!`,
            }}
            roleCheck='create-new-business-name'
            buttonName={{
              name: 'New business name',
              link: '',
              popup: true,
              buttonFun: () => setShowModalNewBusiness(true),
            }}
          />
        )}
        {/* begin::Body */}
      </div>
    </>
  )
}

export default BusinessNameList
